export default "__VITE_ASSET__DN_7j6ck__"